import React from 'react';
import { styled } from '@linaria/react';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  name: string;
  checked: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

function ModeToggle({
  name,
  checked,
  onToggle,
  children,
  ...delegated
}: Props) {
  const id = `${name}-${children}`;

  return (
    <Wrapper {...delegated}>
      <Input
        type="radio"
        name={name}
        id={id}
        checked={checked}
        onChange={onToggle}
      />
      <Label htmlFor={id}>{children}</Label>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
`;

const Input = styled.input`
  position: absolute;
  opacity: 0;
  pointer-events: none;
`;

const Label = styled.label`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 4rem;
  border: 3px solid;
  border-radius: 6px;
  border-color: var(--color-gray-100);
  color: var(--color-gray-500);
  cursor: pointer;
  user-select: none;

  ${Input}:checked + & {
    border-color: var(--color-gray-300);
    color: var(--color-gray-900);
  }

  ${Input}:focus-visible + & {
    outline: 2px solid;
    outline-offset: 4px;
  }

  &:hover {
    border-color: var(--color-gray-200);
    color: var(--color-gray-700);
  }
`;

export default ModeToggle;
